import React from 'react';
import ScopedCssBaseline from '@material-ui/core/ScopedCssBaseline';
import { CssBaseline, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
const useStyles = makeStyles(() => ({
    '@global': {
        '*': {
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale',
        },
        html: {
            overflowX: 'hidden',
        },
        body: {
            /* This fixes a weird wiggle effect on the MUI dropdowns */
            padding: '0 !important',
        },
    },
}));
export const GlobalStyle = ({ addGlobalOverrides = true, scoped, children }) => {
    const styles = useStyles();
    return scoped ? (React.createElement(ScopedCssBaseline, null, children)) : (React.createElement(React.Fragment, null,
        React.createElement(CssBaseline, { classes: { '@global': clsx(addGlobalOverrides && styles['@global']) } }),
        children));
};
